import { useEffect, useRef, useState } from 'react';

const PHASES = [
  { label: 'Breathe in', secs: 4, scale: 1.3 },
  { label: 'Hold', secs: 4, scale: 1.3 },
  { label: 'Breathe out', secs: 6, scale: 0.8 },
];

export default function GiaBreathing({ minutes = 2 }) {
  const [active, setActive] = useState(false);
  const [phaseIdx, setPhaseIdx] = useState(0);
  const [remaining, setRemaining] = useState(minutes * 60);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!active) return undefined;
    let phaseTime = 0;
    timerRef.current = setInterval(() => {
      phaseTime += 1;
      setRemaining((r) => {
        if (r <= 1) { setActive(false); return minutes * 60; }
        return r - 1;
      });
      setPhaseIdx((i) => {
        if (phaseTime % PHASES[i].secs === 0) { phaseTime = 0; return (i + 1) % PHASES.length; }
        return i;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [active, minutes]);

  const phase = PHASES[phaseIdx];
  const mm = Math.floor(remaining / 60);
  const ss = String(remaining % 60).padStart(2, '0');

  return (
    <div className="text-center" data-testid="gia-breathing">
      <div className="flex items-center justify-center" style={{ height: 130 }}>
        <div
          className="w-24 h-24 rounded-full flex items-center justify-center transition-transform ease-in-out border-2"
          style={{
            transform: `scale(${active ? phase.scale : 1})`,
            transitionDuration: '3800ms',
            background: 'radial-gradient(circle, rgba(168,85,247,0.25), rgba(124,58,237,0.08))',
            borderColor: 'rgba(196,181,253,0.5)',
          }}
        >
          <span className="text-[11px] font-bold text-purple-100">{active ? phase.label : 'Ready'}</span>
        </div>
      </div>
      <p className="font-black text-2xl text-white mb-3">{mm}:{ss}</p>
      <button
        onClick={() => { setActive(!active); if (!active) { setRemaining(minutes * 60); setPhaseIdx(0); } }}
        data-testid="gia-breathing-toggle"
        className="px-8 py-2.5 rounded-full text-sm font-bold text-white shadow-lg transition-transform active:scale-95"
        style={{ background: 'linear-gradient(135deg,#a855f7,#7c3aed)' }}
      >
        {active ? 'Stop' : `Start ${minutes}-min breathing`}
      </button>
    </div>
  );
}
